// Canonical protein vocabulary, mirrored from the backend's
// PROTEIN_INGREDIENT_KEYS (services/recipeConstants.ts). Priority-ordered
// [key, display] tuples: `key` matches a recipe's ingredientKeys, `display` is
// the lowercase human phrase.
//
// This is the single source of truth on the frontend: feedbackTags.ts consumes
// the tuples to label the dislike_protein chip, and the "Other proteins"
// autocomplete inputs (onboarding + profile) use PROTEIN_SUGGESTIONS.
export const PROTEIN_KEY_DISPLAY: Array<[string, string]> = [
  ['chicken', 'chicken'],
  ['turkey', 'turkey'],
  ['beef', 'beef'],
  ['pork', 'pork'],
  ['lamb', 'lamb'],
  ['salmon', 'salmon'],
  ['tuna', 'tuna'],
  ['white_fish', 'white fish'],
  ['shrimp', 'shrimp'],
  ['shellfish', 'shellfish'],
  ['tofu', 'tofu'],
  ['tempeh', 'tempeh'],
  ['seitan', 'seitan'],
  // After the specific plant proteins: a seitan dish should read as seitan,
  // and only fall back to the generic substitute label otherwise.
  ['plant_based_meat', 'plant-based meat'],
  ['lentils', 'lentils'],
  ['chickpeas', 'chickpeas'],
  ['black_beans', 'black beans'],
  ['kidney_beans', 'kidney beans'],
  ['white_beans', 'white beans'],
  ['beans_generic', 'beans'],
  // Supporting proteins last — rarely the dish's centerpiece
  ['sausage', 'sausage'],
  ['bacon', 'bacon'],
  ['eggs', 'eggs'],
  // Last: a complete protein, but almost always the base rather than the
  // centrepiece. A quinoa bowl with chickpeas is a chickpea dish. Only
  // surfaces as "the" protein when nothing above it is present — 3 recipes
  // across the catalog, so this is for completeness rather than coverage.
  ['quinoa', 'quinoa'],
];

// Title-cased protein names for the "Other proteins" autocomplete inputs.
// Matches the UI's title-case convention for protein chips (e.g. "White fish",
// "Black beans"). Only the first letter is upper-cased so multi-word phrases
// stay readable.
export const PROTEIN_SUGGESTIONS: string[] = PROTEIN_KEY_DISPLAY.map(
  ([, display]) => display.charAt(0).toUpperCase() + display.slice(1)
);
